import styled from 'styled-components';
import { LinkBox as ChakraLinkBox, Link as NavLink, Text, Heading } from '@chakra-ui/react';
import { colors } from '../../../theme/colors';
interface Props {
  $isDisabled?: boolean;
}

export const LinkBox = styled(ChakraLinkBox)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  padding: 1.5em 1.5rem 1rem;
  border-radius: 5px;
  font-size: 16px;
  background-color: ${({ theme }) => theme.colors[1300]};
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);

  filter: drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.1));

  border: 1px solid ${({ theme }) => theme.colors.tertiary};
  transition: 0.2s ease;

  .svgImage {
    width: 1.6rem;
    height: 1.6rem;
  }

  ${(props: Props) =>
    !props.$isDisabled
      ? `
    &:hover {
      box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.2);
      background:  #7E225A;
      cursor: pointer !important;

      .textLabel {
        color: white;
      }

      .svgImage {
        filter: invert(100%);
      }
    }
    `
      : `
    opacity: .75;
  `}

  &:[aria-expanded='true']
  &:[aria-selected='true'] {
    background-color: red;
  }
`;

export const Link = styled(NavLink)`
  position: relative;
  font-weight: 700;
  font-size: 14px;
  &:hover {
    text-decoration: none;
  }

  &:focus {
    border: 0;
  }

  &:focus-within {
    border: 0;
  }

  &::before {
    content: '';
    position: absolute;
    bottom: -1px;
    width: 100%;
    height: 2px;
    background-color: ${colors.brand.tertiary};
  }
`;

export const LabelText = styled(Text)`
  /* font-family: Proxima Nova; */
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  text-align: left;
`;

export const extHeading = styled(Heading)`
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
`;
